module.exports = __webpack_public_path__ + "img/img-works_1.aecbb61b.png";